import { createCRUDHook } from './createCRUDHook';
import { checkListTemplateStepsDto } from 'utils/models';
import {
  TBL_CHECKLIST_TEMPLATE_STEP,
  TBL_CHECKLIST_TEMPLATE_PART_BY_TEMPLATEID,
} from './apiEndPoints';

interface CheckListTemplateStepCustomOperations {
  getCheckListTemplateStepsByTemplateId: (
    templateId: number
  ) => Promise<checkListTemplateStepsDto[]>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  checkListTemplateStepsDto,
  checkListTemplateStepsDto[],
  CheckListTemplateStepCustomOperations
>({
  entityName: 'CheckListTemplateStep',
  endpoint: TBL_CHECKLIST_TEMPLATE_STEP,

  customOperations: (auth) => ({
    getCheckListTemplateStepsByTemplateId: async (
      templateId: number
    ): Promise<checkListTemplateStepsDto[]> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TBL_CHECKLIST_TEMPLATE_STEP +
            TBL_CHECKLIST_TEMPLATE_PART_BY_TEMPLATEID +
            `/${templateId}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const CheckListTemplateStepContext = Context;
export const useCheckListTemplateStepManager = useManager;
export const useCheckListTemplateStep = useConsumer;
